import { render, staticRenderFns } from "./checkbox-switch.vue?vue&type=template&id=8f285868&scoped=true"
import script from "./checkbox-switch.vue?vue&type=script&lang=js"
export * from "./checkbox-switch.vue?vue&type=script&lang=js"
import style0 from "./checkbox-switch.vue?vue&type=style&index=0&id=8f285868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f285868",
  null
  
)

export default component.exports